import React, { Component } from "react";
import "./Login.css";
import axios from "axios";
import "./Signin.css";

import { Link } from "react-router-dom";

class Signin extends Component {
  state = {
    credentials: { username: "", password: "" },
    validationErrors: [],
    loading: false,
  };

  login = (event) => {
    let service = axios.create({
      baseURL: this.props.baseUrl + "/api",
      responseType: "json",
    });

    let credentials = this.state.credentials;
    credentials.username = credentials.username.toLowerCase();

    service
      .post("/auth/", credentials)
      .then((response) => {
        if (response.data.token) {
          this.props.userToken(response.data.token);
          this.props.userLogin(this.state.credentials.username);
          const tokenvalue =
            this.state.credentials.username + "###" + response.data.token;
          this.props.setCookie("spatiamtoken", tokenvalue, {
            path: this.props.baseDir,
            maxAge: 43200,
          });
          window.location = this.props.baseDir
        }
        this.setState({loading:false });
      })
      .catch((errors) => {
        if(errors.response){
          this.setState({ validationErrors: errors.response.data, loading:false });
        }
        else{
          this.setState({ validationErrors: {internal:"An error ocurred, please try again."}, loading:false });
        }
      });
    return;
  };

  inputChanged = (event) => {
    const cred = this.state.credentials;
    cred[event.target.name] = event.target.value;
    this.setState({ credentials: cred });
  };

  renderErrors = () => {
    if (this.props.getRegistered()) {
      return (
        <li style={{ color: "rgb(30, 255, 0)" }} key={"registration success"}>
          Registration Successful. Please Sign In
        </li>
      );
    }

    const validationErrors = this.state.validationErrors;

    const error_tags = ["username", "password", "internal", "non_field_errors"];
    let errors = [];

    if(!validationErrors){
      errors.push(
        <p style={{ color: "red" }} key="SignInError">
          Sign in error, try again later
        </p>
      );
      return errors;
    }
    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      var msg = "";
      if (error_msg) {
        if (error_tag === "username") {
          msg = "Username required.";
        } else if (error_tag === "password") {
          msg = "Password required.";
        } else if(error_tag === "internal"){
          msg = error_msg
        } else {
          msg = "Invalid username or password.";
        }
        errors.push(
          <p style={{ color: "red" }} key={error_tags[i]}>
            {msg}
          </p>
        );
      }
    }

    return errors;
  };

  render() {
    return (
      <div className="input_area">
        <div className="title_area">
          <h1>Sign In</h1>
        </div>
        <form
          onSubmit={(event) => {
            this.setState({loading: true})
            event.preventDefault();
            this.props.setRegistered(false);
            this.login();
          }}
        >
          <label>Username:</label>
          <input
            type="text"
            name="username"
            value={this.state.credentials.username}
            onChange={this.inputChanged}
            maxLength="100"
          />
          <label>Password:</label>
          <input
            type="password"
            name="password"
            value={this.state.credentials.password}
            onChange={this.inputChanged}
            maxLength="1000"
          />
          <button type="submit" className="login_button" disabled={this.state.loading}>
            {this.state.loading ? "..." : "Sign In"}
          </button>
        </form>
        <div style={{ textAlign: "right", marginTop: "5px" }}>
          <Link to={this.props.baseDir+"/recover"}> Forgot username or password?</Link>
        </div>
        <>{this.renderErrors()}</>
        <div className="separator">Don't have an account?</div>
        <a href={this.props.baseDir+"/join/"}>
          <button
            className="register_button"
          >
            Request Beta Access
          </button>
        </a>
      </div>
    );
  }
}

export default Signin;
